import { jsx as N, jsxs as c } from "react/jsx-runtime";
import { useMemo as m } from "react";
const v = ({
  measurementUnit: a,
  skuSpecifications: d,
  unitMultiplier: r
}) => {
  const g = "Venda por unidade", e = d == null ? void 0 : d.some((s) => s.field.originalName === g && s.values.some((h) => h.originalName === "true")), n = m(() => e ? null : r > 1 ? r : r === 1 ? null : r * 1e3, [e, r]), o = m(() => e ? "Un" : r * 1e3 >= 1e3 ? a : "g", [e, a, r]);
  if (!(!n || !o))
    return /* @__PURE__ */ N("div", { className: "product-card-badge", children: /* @__PURE__ */ c("p", { className: "product-card-badge-kg", children: [
      n,
      o
    ] }) });
};
export {
  v as ProductCardBadgeKg
};
